import { ParentPlaceIdTag, PlaceTag } from 'interfaces/vector.interface';
import extractValuesForPlaceTag from 'utils/extractValuesForPlaceTag';

const getPlaceTagValue = (
	placeTags: PlaceTag[],
	tagName: string,
	tagPropertykey: string,
	valueType?: string,
): string[] | number[] | boolean[] | ParentPlaceIdTag[] => {
	let value = [];
	for (let i = 0; i < placeTags?.length; i++) {
		if (
			placeTags[i].TagName === tagName &&
			placeTags[i].TagPropertyKey === tagPropertykey
		) {
			if (valueType !== undefined) {
				if (placeTags[i].value.valueType === valueType) {
					value = extractValuesForPlaceTag(placeTags[i].value);
					// eslint-disable-next-line no-continue
				} else continue;
			} else {
				value = extractValuesForPlaceTag(placeTags[i].value);
			}
			break;
		}
	}
	return value;
};

export default getPlaceTagValue;
